import React, { Component } from 'react'
import fire from '../../config/Fire'
import { Redirect } from 'react-router'
import './Login.css'

class Login extends Component {
  constructor(props) {
    super(props)
    this.login = this.login.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.state = {
      email: '',
      redirect: false,
    }
  }

  actionCodeSettings = {
    // URL you want to redirect back to.
    url: 'https://treetrackerapp.com/confirm-email',
    handleCodeInApp: true,
    iOS: {
    },
    android: {
    }
  }

  handleChange(e) {
    this.setState({ [e.target.name]: e.target.value })
  }

  login(e) {
    e.preventDefault()

    // Save the email locally so you don't need to ask the user for it again
    // if they open the link on the same device.
    localStorage.setItem('emailForSignIn', this.state.email);

    fire.auth().sendSignInLinkToEmail(this.state.email, this.actionCodeSettings)
      .then(() =>
        // The link was successfully sent. Inform the user.
        this.setState({ redirect: true })
      )
      .catch((error) =>
        // Some error occurred, you can inspect the code: error.code
        localStorage.removeItem('emailForSignIn')
      );
  }

  render() {
    if (this.state.redirect === true) {
      return <Redirect to='/check-email' />
    }

    return (
      <div>
        <nav className="navbar navbar-expand-lg navbar-dark navbar-custom fixed-top">
          <div className="container">
            <a className="navbar-brand" href="/">Tree Tracker App</a>
          </div>
        </nav>

        <div className="col-md-5 margin-top-container">
          <form>
            <div className="form-group">
              <label >Email address</label>
              <input value={this.state.email}
                onChange={this.handleChange}
                type="email"
                name="email"
                className="form-control"
                aria-describedby="emailHelp"
                placeholder="Enter email" />
              <small id="emailHelp" className="form-text text-muted">
                We'll never share your email with anyone else.
            </small>
            </div>
            <button type="submit" onClick={this.login} className="btn btn-primary">Login</button>
          </form>
        </div>

        <footer className="py-5 bg-black bottom-footer ">
          <div className="container">
            <p className="m-0 text-center text-white small">Copyright &copy; Tree Tracker App {new Date().getFullYear()}</p>
          </div>
        </footer>

      </div>
    )
  }
}
export default Login




// WEBPACK FOOTER //
// ./src/components/login/Login.js